/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUsersImport } from '../fn/users-import/get-users-import';
import { GetUsersImport$Params } from '../fn/users-import/get-users-import';
import { getUsersImportJobLogs } from '../fn/users-import/get-users-import-job-logs';
import { GetUsersImportJobLogs$Params } from '../fn/users-import/get-users-import-job-logs';
import { getUsersImportStatus } from '../fn/users-import/get-users-import-status';
import { GetUsersImportStatus$Params } from '../fn/users-import/get-users-import-status';
import { getUsersImportTemplate } from '../fn/users-import/get-users-import-template';
import { GetUsersImportTemplate$Params } from '../fn/users-import/get-users-import-template';
import { postUsersImport } from '../fn/users-import/post-users-import';
import { PostUsersImport$Params } from '../fn/users-import/post-users-import';
import { UsersImportJobLogsResponse } from '../models/users-import-job-logs-response';
import { UsersImportJobResponse } from '../models/users-import-job-response';
import { UsersImportJobsResponse } from '../models/users-import-jobs-response';
import { UsersImportResponse } from '../models/users-import-response';
import { UsersImportTemplateResponse } from '../models/users-import-template-response';

@Injectable({ providedIn: 'root' })
export class UsersImportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUsersImportTemplate()` */
  static readonly GetUsersImportTemplatePath = '/users-import-template';

  /**
   * Returns the public url to download the users import template
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersImportTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImportTemplate$Response(params: GetUsersImportTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportTemplateResponse>> {
    return getUsersImportTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the public url to download the users import template
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersImportTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImportTemplate(params: GetUsersImportTemplate$Params, context?: HttpContext): Observable<UsersImportTemplateResponse> {
    return this.getUsersImportTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersImportTemplateResponse>): UsersImportTemplateResponse => r.body)
    );
  }

  /** Path part for operation `getUsersImport()` */
  static readonly GetUsersImportPath = '/users-import';

  /**
   * Returns the status of all users import jobs
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersImport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImport$Response(params: GetUsersImport$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportJobsResponse>> {
    return getUsersImport(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the status of all users import jobs
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersImport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImport(params: GetUsersImport$Params, context?: HttpContext): Observable<UsersImportJobsResponse> {
    return this.getUsersImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersImportJobsResponse>): UsersImportJobsResponse => r.body)
    );
  }

  /** Path part for operation `postUsersImport()` */
  static readonly PostUsersImportPath = '/users-import';

  /**
   * Returns the public url to upload the users import file
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUsersImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsersImport$Response(params: PostUsersImport$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportResponse>> {
    return postUsersImport(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the public url to upload the users import file
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUsersImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUsersImport(params: PostUsersImport$Params, context?: HttpContext): Observable<UsersImportResponse> {
    return this.postUsersImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersImportResponse>): UsersImportResponse => r.body)
    );
  }

  /** Path part for operation `getUsersImportStatus()` */
  static readonly GetUsersImportStatusPath = '/users-import/{jobId}';

  /**
   * Returns the status of the users import job
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersImportStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImportStatus$Response(params: GetUsersImportStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportJobResponse>> {
    return getUsersImportStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the status of the users import job
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersImportStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImportStatus(params: GetUsersImportStatus$Params, context?: HttpContext): Observable<UsersImportJobResponse> {
    return this.getUsersImportStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersImportJobResponse>): UsersImportJobResponse => r.body)
    );
  }

  /** Path part for operation `getUsersImportJobLogs()` */
  static readonly GetUsersImportJobLogsPath = '/users-import/{jobId}/logs';

  /**
   * Returns the logs of the users import job
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersImportJobLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImportJobLogs$Response(params: GetUsersImportJobLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportJobLogsResponse>> {
    return getUsersImportJobLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the logs of the users import job
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersImportJobLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersImportJobLogs(params: GetUsersImportJobLogs$Params, context?: HttpContext): Observable<UsersImportJobLogsResponse> {
    return this.getUsersImportJobLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersImportJobLogsResponse>): UsersImportJobLogsResponse => r.body)
    );
  }

}
